import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SbPieChartModel } from '@ngx-seatback/charts';
import { BookingStatusService } from 'src/app/services/booking-status/booking-status.service';
import { BookingStatus, TimingStatus } from 'src/app/services/api/api';

@Component({
  selector: 'sb-verification-progress',
  templateUrl: './sb-verification-progress.component.html',
  styleUrls: ['./sb-verification-progress.component.scss'],
  standalone: false,
})
export class SbVerificationProgressComponent implements OnInit {
  @Input() bookingStatus: any[];
  bookingCount = 0;
  verifiedBookings = 0;
  verifiedPercentage = 0;
  smallPie: SbPieChartModel;

  constructor(
    public translate: TranslateService,
    public bookingStatusService: BookingStatusService
  ) {}

  getVerifications() {
    const bookingStatus = this.bookingStatusService.getReasons(this.bookingStatus, [TimingStatus.Present, TimingStatus.Future]);
    this.bookingCount = 0;
    this.verifiedPercentage = 0;

    if (!bookingStatus || bookingStatus.size < 1) {
      this.bookingCount = 0;
      this.verifiedPercentage = 0;
      return;
    }

    for (const [key, value] of bookingStatus.entries()) {
      if (
        key !== BookingStatus.Excluded &&
        key !== BookingStatus.Paused &&
        key !== BookingStatus.Deleted &&
        key !== BookingStatus.Proposed &&
        key !== BookingStatus.Deprecated
      ) {
        this.bookingCount += value;
      }
      if (key === BookingStatus.Active) {
        this.verifiedBookings = value;
      }
    }

    if (this.verifiedBookings > 0 && this.bookingCount > 0) {
      this.verifiedPercentage = Math.round((this.verifiedBookings / this.bookingCount) * 100);
    }
    this.smallPie = {
      title: 'title',
      height: 50,
      value: 'value',
      category: 'category',
      radius: 50,
      customLabel: this.verifiedPercentage,
      fontSize: 11,
      data: [
        {
          category: this.translate.instant('lang.globals.verified'),
          value: this.verifiedPercentage,
          label: 'Verified',
          color: '#31AB50', // sbGreen-600
        },
        {
          category: this.translate.instant('lang.globals.pending'),
          value: 100 - this.verifiedPercentage,
          color: '#CACED5', // sbGray-300
        },
      ],
    };
  }

  ngOnInit(): void {
    this.getVerifications();
    this.translate.onDefaultLangChange.subscribe(() => {
      this.getVerifications();
    });
  }
}
